import { graphql } from "@/lib/gql/__generated__";

export const PlanList_DesignPage_Query = graphql(`
	query PlanList_DesignPage($hotelID: ID!) {
		planList(hotelID: $hotelID) {
			id
			hotelID
			plans {
				id
				planID
				inSale
				isPrivate
				isRequest
				isDayTrip
				name
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				articleTitle
			}
			secrets {
				id
				planID
				inSale
				isPrivate
				isRequest
				isDayTrip
				name
				articleTitle
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}
	}
`);
